import { api } from "../../lib/api";

export interface OppMedia {
  id: string;
  kind: string;
  url: string | null;
  thumbnailUrl: string | null;
  caption: string | null;
  position: number;
  width: number | null;
  height: number | null;
  durationSeconds: number | null;
  status: string;
}

export interface Opportunity {
  id: string;
  title: string;
  slug: string | null;
  type: string;
  summary: string | null;
  body: string | null;
  securityId: string | null;
  ctaLabel: string;
  expectedYield: string | null;
  minTicket: string | null;
  status: "draft" | "scheduled" | "published" | "archived";
  scheduledAt: string | null;
  publishedAt: string | null;
  viewCount: number;
  createdAt: string;
  updatedAt: string;
  media: OppMedia[];
}

export interface OpportunityInput {
  title: string;
  type: string;
  summary?: string | null;
  body?: string | null;
  ctaLabel?: string;
  expectedYield?: string | null;
  minTicket?: string | null;
  status?: string;
  scheduledAt?: string | null;
}

export const listOpportunities = () =>
  api<{ data: Opportunity[] }>("/admin/opportunities").then((r) => r.data);

export const createOpportunity = (body: OpportunityInput) =>
  api<{ opportunity: Opportunity }>("/admin/opportunities", { method: "POST", body }).then(
    (r) => r.opportunity,
  );

export const updateOpportunity = (id: string, body: Partial<OpportunityInput>) =>
  api<{ opportunity: Opportunity }>(`/admin/opportunities/${id}`, { method: "PATCH", body }).then(
    (r) => r.opportunity,
  );

export const uploadOpportunityMedia = (id: string, file: File, caption?: string) => {
  const form = new FormData();
  form.append("file", file);
  if (caption) form.append("caption", caption);
  return api<{ media: OppMedia }>(`/admin/opportunities/${id}/media`, {
    method: "POST",
    body: form,
    rawBody: true,
  }).then((r) => r.media);
};

export const deleteOpportunityMedia = (id: string, mediaId: string) =>
  api<{ ok: true }>(`/admin/opportunities/${id}/media/${mediaId}`, { method: "DELETE" });
